export var ChatWidgetPosition;
(function (ChatWidgetPosition) {
    ChatWidgetPosition[ChatWidgetPosition["Custom"] = 1] = "Custom";
    ChatWidgetPosition[ChatWidgetPosition["BottomRight"] = 2] = "BottomRight";
    ChatWidgetPosition[ChatWidgetPosition["BottomLeft"] = 3] = "BottomLeft";
    ChatWidgetPosition[ChatWidgetPosition["Default"] = 2] = "Default";
})(ChatWidgetPosition || (ChatWidgetPosition = {}));
//# sourceMappingURL=chat-widget-position.js.map